import { userService } from '@/services/userService'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PAGE_LINKS } from '@/router/pageConst'
import { getProductDashboardLink } from '@/router/pageConst'
import ProductSwitchHoverPanel, {
  ProductSwitchHoverPanelColumn,
} from '@/components/ProductSwitchHoverPanel/ProductSwitchHoverPanel'
import styles from './ProductEntryBtn.module.less'


function ProductEntryBtn() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const navigateWithAuth = (path: string) => {
    if (!userService.userInfo || userService.userInfo.isExpert) {
      navigate(PAGE_LINKS.login, { state: { mode: 'login' } })
      return
    }
    navigate(path)
  }

  const getTitleWithoutOrientation = (title: string) => {
    const [, shortTitle] = title.split('-', 2)
    return shortTitle || title
  }

  const columns: ProductSwitchHoverPanelColumn[] = [
    {
      key: 'tvc',
      tone: 'purple',
      bannerTitle: t('productSwitch.hoverPanel.columns.tvc.bannerTitle'),
      assetText: t('productSwitch.hoverPanel.columns.tvc.assetText'),
      items: [
        {
          key: 'horizontal-quick',
          title: getTitleWithoutOrientation(t('productSwitch.modal.cards.tvcQuick.title')),
          description: t('productSwitch.hoverPanel.items.tvcQuick.description'),
          onClick: () => navigateWithAuth(getProductDashboardLink('horizontal-quick', 'project')),
        },
        {
          key: 'horizontal-base',
          title: t('productSwitch.hoverPanel.items.tvcBase.title'),
          description: t('productSwitch.hoverPanel.items.tvcBase.description'),
          onClick: () => navigateWithAuth(getProductDashboardLink('horizontal-base', 'project')),
        },
        {
          key: 'horizontal-survey',
          title: t('productSwitch.hoverPanel.items.tvcSurvey.title'),
          description: t('productSwitch.hoverPanel.items.tvcSurvey.description'),
          onClick: () => navigateWithAuth(getProductDashboardLink('horizontal-survey', 'project')),
        },
      ],
    },
    {
      key: 'portrait',
      tone: 'blue',
      bannerTitle: t('productSwitch.hoverPanel.columns.portrait.bannerTitle'),
      assetText: t('productSwitch.hoverPanel.columns.portrait.assetText'),
      items: [
        {
          key: 'portrait-quick',
          title: getTitleWithoutOrientation(t('productSwitch.modal.cards.portraitQuick.title')),
          description: t('productSwitch.hoverPanel.items.portraitQuick.description'),
          onClick: () => navigateWithAuth(getProductDashboardLink('portrait-quick', 'project')),
        },
        {
          key: 'portrait-base',
          title: t('productSwitch.hoverPanel.items.portraitBase.title'),
          description: t('productSwitch.hoverPanel.items.portraitBase.description'),
          onClick: () => navigateWithAuth(getProductDashboardLink('portrait-base', 'project')),
        },
        {
          key: 'portrait-survey',
          title: t('productSwitch.hoverPanel.items.portraitSurvey.title'),
          description: t('productSwitch.hoverPanel.items.portraitSurvey.description'),
          onClick: () => navigateWithAuth(getProductDashboardLink('portrait-survey', 'project')),
        },
      ],
    },
  ]

  return (
    <div className={styles.productEntryBtn} data-testid='page-header-product-entry'>
      <button type='button' className={styles.triggerText} data-testid='page-header-product-entry-btn'>
        {t('pageHeader.product')}
      </button>
      <div className={styles.hoverPanel}>
        <div className={styles.hoverPanelInner}>
          <ProductSwitchHoverPanel columns={columns} />
        </div>
      </div>
    </div>
  )
}

export default observer(ProductEntryBtn)
